import createIcon from '../../createIcon';

/**
 * @component @name Scale
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTFWOEMxOC41NiA3LjQyIDIyIDQuOSAyMiAySDJDMiA0LjkgNS40NCA3LjQyIDEwIDhWMTFDNi4zMiAxMS43MyAyIDE0LjYxIDIgMjJIOFYyMEg0LjEzQzUuMDYgMTMuMTcgMTAuNzggMTIuOCAxMiAxMi44QzEzLjIyIDEyLjggMTguOTQgMTMuMTcgMTkuODcgMjBIMTZWMjJIMjJDMjIgMTQuNjEgMTcuNjggMTEuNzMgMTQgMTFaTTEyIDIyQzEwLjkgMjIgMTAgMjEuMSAxMCAyMEMxMCAxOS40NSAxMC4yMiAxOC45NSAxMC41OSAxOC41OUMxMS4zOSAxNy43OSAxNiAxNiAxNiAxNkMxNiAxNiAxNC4yMSAyMC42MSAxMy40MSAyMS40MUMxMy4wNSAyMS43OCAxMi41NSAyMiAxMiAyMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Scale = createIcon('Scale', [
  [
    'path',
    {
      d: 'M14 11V8C18.56 7.42 22 4.9 22 2H2C2 4.9 5.44 7.42 10 8V11C6.32 11.73 2 14.61 2 22H8V20H4.13C5.06 13.17 10.78 12.8 12 12.8C13.22 12.8 18.94 13.17 19.87 20H16V22H22C22 14.61 17.68 11.73 14 11ZM12 22C10.9 22 10 21.1 10 20C10 19.45 10.22 18.95 10.59 18.59C11.39 17.79 16 16 16 16C16 16 14.21 20.61 13.41 21.41C13.05 21.78 12.55 22 12 22Z',
      key: '1ajb71',
    },
  ],
]);

export default Scale;
